module.exports = __webpack_public_path__ + "static/img/training_widget_3.cf7f686.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/training_widget_3.png
// module id = 52ls
// module chunks = 11